import FeedbackWidget from "./FeedbackWidget";

export default FeedbackWidget;
